function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
import { baseProductValidatorSharedMap } from "./SWBaseProduct";
/** @public */ export const resourceIdValidator = idValidator("product_detail");
/** @public */ export function createProductDetailValidator(type, props, meta) {
    return T.object(_object_spread({
        id: resourceIdValidator,
        typeName: T.literal("product_detail"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        rawPrice: T.number,
        rawTrialPeriodPrice: T.number,
        trialPeriodDays: T.number,
        period: T.literalEnum("lifetime", "year", "6 month", "quarter", "2 month", "month", "week", "day")
    }, baseProductValidatorSharedMap));
}
